import {CalendarUtil} from "../lib/CalendarUtil";

/**
 * The configuration of the initial page settings. Please note, that all page settings must have an initial value,
 * otherwise the application bootstrap will fail.
 *
 * At login time, some of the settings may be overwritten, depending on the user's role. For instance if a user with
 * the role 'foreman' is logging in, all formanFilter will be set to its user id. This is done in the login() methode
 * of the AppCtx component.
 */

const currentWeek = CalendarUtil.isoWeek();

export const pageCfg = {
    ProjectList: {
        view            : 'assignView',
        deputy          : false,
        foremanFilter   : -1
    },
    ProjectListAvor: {
        view            : 'openView',
        projectRef      : '',
        projectDesc     : '',
        foreman         : -1,
        deputy          : -1,
        avorBy          : -1,
        avorFrom        : null,
        avorTo          : null
    },
    ProjectDetail: {
        taskView        : 'allTaskView'
    },
    ProjectSearch: {
        view            : 'currentView'
    },
    TaskList: {
        view            : 'dayView',
        deputy          : false,
        member          : false,
        capa            : false,
        week            : currentWeek,
        day             : currentWeek.days[currentWeek.initialDayIdx],
        dayIndex        : currentWeek.initialDayIdx,
        foremanFilter   : -1,
        groupFilter     : -1,
        memberFilter    : -1,
        taskFilter      : -1,
        displayOption   : 0,
        showNumbers     : true
    },
    TaskSearch: {
        view            : 'currentView'
    },
    CrewList: {
        crewView        : 'activeView',
        contractorView  : 'activeView',
        roleFilter      : -1
    },
    CodeList: {
        taskCode: 'task.0',
        catView : 'activeView',
        taskView: 'activeView',
        toolView: 'activeView'
    }
}